import { render } from "./UserUpload.vue?vue&type=template&id=46c3a9a9&scoped=true"
import script from "./UserUpload.vue?vue&type=script&lang=js"
export * from "./UserUpload.vue?vue&type=script&lang=js"

import "./UserUpload.vue?vue&type=style&index=0&id=46c3a9a9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c3a9a9"]])

export default __exports__